import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-subtitle" }
const _hoisted_2 = { class: "border-t border-b border-dashed border-gray-300 py-2 mb-6" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.seminarDetails)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.seminarDetails.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "v-html whitespace-pre-wrap",
            innerHTML: _ctx.seminarDetails.summary
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", {
          class: "v-html whitespace-pre-wrap mb-6",
          innerHTML: _ctx.seminarDetails.body
        }, null, 8, _hoisted_4)
      ], 64))
    : _createCommentVNode("", true)
}